import { createContext, useContext } from "react"

import { ContextMenu, createContextMenu } from "@/components/ContextMenu"
import { Client } from "@/types"
import { signInPOS } from "@/utils"

import { ClientDetailsPanel } from "./partials/ClientDetailsPanel"
import { DistanceLimitModal } from "./partials/DistanceLimitModal"
import { UpdateWorkingHoursModal } from "./partials/UpdateWorkingHoursModal"

export type ClientContextMenuAction = {
  action: "update_distance_limit" | "update_working_hours" | "show_details"
  clientId: Client["id"]
} | null

export const ClientItemContext = createContext<{
  clientContextMenuAction: ClientContextMenuAction
  setClientContextMenuAction: (action: ClientContextMenuAction) => void
} | null>(null)

export const {
  ContextMenuWrapper: ClientsContextMenuWrapper,
  useContextMenuEvent: useClientsContextMenuEvent,
  useContextMenuTrigger: useClientsContextMenuTrigger,
} = createContextMenu<{
  clientId: Client["id"]
}>("clientsList")

export const ClientContextMenu = () => {
  return (
    <>
      <ClientsContextMenuWrapper>
        <ContextMenuItems />
      </ClientsContextMenuWrapper>

      <ContextMenuActions />
    </>
  )
}

export const ContextMenuItems = () => {
  const { setClientContextMenuAction } = useContext(ClientItemContext) || {}

  const {
    data: { clientId },
  } = useClientsContextMenuEvent()

  if (!setClientContextMenuAction) return null

  return (
    <ContextMenu>
      <ContextMenu.Item
        iconName="speedometer"
        onClick={() => setClientContextMenuAction({ action: "update_distance_limit", clientId })}
      >
        Zmiana limitu km
      </ContextMenu.Item>

      <ContextMenu.Item iconName="google-maps" onClick={() => signInPOS(clientId)}>
        Zaloguj się do lokalizacji (POS)
      </ContextMenu.Item>

      <ContextMenu.Item
        iconName="clock"
        onClick={() => setClientContextMenuAction({ action: "update_working_hours", clientId })}
      >
        Wydłuż godziny pracy
      </ContextMenu.Item>
    </ContextMenu>
  )
}

const ContextMenuActions = () => {
  const { clientContextMenuAction, setClientContextMenuAction } = useContext(ClientItemContext) || {}

  if (!clientContextMenuAction || !setClientContextMenuAction) return null

  const { action, clientId } = clientContextMenuAction

  switch (action) {
    case "show_details":
      return <ClientDetailsPanel clientId={clientId} handleClose={() => setClientContextMenuAction(null)} />

    case "update_distance_limit":
      return <DistanceLimitModal clientId={clientId} handleClose={() => setClientContextMenuAction(null)} />

    case "update_working_hours":
      return <UpdateWorkingHoursModal clientId={clientId} handleClose={() => setClientContextMenuAction(null)} />
  }
}
